export type ColorScheme = 'dark' | 'light'

const colorSchemeClasses = [
  'scheme-dark',
  'scheme-light',
  'scheme-light-dark',
] as const

export const colorSchemeStorageKey = '__levery_theme'
export const colorSchemeChangeEvent = 'levery-color-scheme-change'

export function getColorScheme(): ColorScheme {
  return document.documentElement.classList.contains('scheme-dark')
    ? 'dark'
    : 'light'
}

export function initializeColorScheme() {
  const stored = window.localStorage.getItem(colorSchemeStorageKey)
  applyColorScheme(stored === 'dark' ? 'dark' : 'light')
}

export function toggleColorScheme() {
  const next = getColorScheme() === 'light' ? 'dark' : 'light'
  applyColorScheme(next, true)
  return next
}

function applyColorScheme(colorScheme: ColorScheme, persist = false) {
  const root = document.documentElement
  root.classList.remove(...colorSchemeClasses)
  root.classList.add(`scheme-${colorScheme}`)

  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', colorScheme === 'dark' ? '#09090b' : '#ffffff')

  if (persist) {
    const oldValue = window.localStorage.getItem(colorSchemeStorageKey)
    window.localStorage.setItem(colorSchemeStorageKey, colorScheme)
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: colorSchemeStorageKey,
        newValue: colorScheme,
        oldValue,
        storageArea: window.localStorage,
      }),
    )
  }

  window.dispatchEvent(
    new CustomEvent<ColorScheme>(colorSchemeChangeEvent, {
      detail: colorScheme,
    }),
  )
}
